import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { useData } from "../../DataContext";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Helmet } from "react-helmet";
import {
    Radio,
    RadioGroup,
    FormControlLabel,
    FormLabel,
    FormControl,
    Button,
    Box,
    InputLabel,
    Checkbox,
    Modal,
    Fade,
    Typography,
    TextareaAutosize
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import './ApplicationDetail.scss'

import {
    Navbar,
    Header,
    StepHeader,
    FormBox,
    BootstrapInput,
    FileInput,
    Footer,
    LoadingSpinner,
} from '../../components/_index'
import { useYupValidationResolver } from '../../YupValidationResolver';
import ErrorsContainer from '../../components/ErrorsContainer/ErrorsContainer';
import Scroll from 'react-scroll';
import { checkIfRedirect, isEmpty, uploadFiles } from '../../utils';
import errorWarning from '../../images/icon_warning.gif'

const useStyles = makeStyles((theme) => ({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      width: 360,
    },
}));

export default withTranslation()(function ApplicationDetail({t, i18n}) {
    let scroll = Scroll.animateScroll;
    const { setValues, data } = useData();
    const lang = i18n.language;
    const history = useHistory();
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    let [ customError, setCustomError ] = useState({});

    checkIfRedirect(data, history);

    const schema = yup.object().shape({
        applicationReason: yup.string().required(t("errors.frontend.790-E-0701")).max(150, t("errors.frontend.790-E-0702")),
        endorseFiles: yup.array().max(8).test('insert-file', t("errors.frontend.790-E-0703"), (value) => (value.length === 0)? false : true),
                // .test('upload-file-fail', t("errors.frontend.790-E-0705"), async (files) => {
                //     if (files.length < 1) {
                //         return true
                //     }
                //     const uploadFilesResult = await uploadFiles(files);
                //     if(!isEmpty(uploadFilesResult)){
                //         setValues({endorseFilesId: uploadFilesResult});
                //         return true
                //     }else{
                //         return false
                //     }
                // }),
        otherFiles: yup.array().max(8),
                // .test('upload-file-fail', t("errors.frontend.790-E-0706"), async (files) => {
                //     if (files.length < 1) {
                //         return true
                //     }
                //     const uploadFilesResult = await uploadFiles(files);
                //     if(!isEmpty(uploadFilesResult)){
                //         setValues({otherFilesId: uploadFilesResult});
                //         return true
                //     }else{
                //         return false
                //     }
                // }),
        collectMethod: yup.string().test("collectMethod Required", t("errors.frontend.790-E-0707"), (value)=>{
            if(data.iWant!=="one"){
                return true
            } else {
                return !isEmpty(value)
            }
        })
    })

    const {
        register,
        handleSubmit,
        control,
        errors,
        clearErrors,
        reset,
        watch,
        getValues,
        setValue
    } = useForm({
        defaultValues: {
            applicationReason: data.applicationReason || '',
            otherFiles: data.otherFiles || [],
            preferredLang: data.preferredLang || 'english',
            collectMethod: data.collectMethod || 'post',
            endorseFiles: data.endorseFiles || []
        },
        mode: "onSubmit",
        resolver: useYupValidationResolver(schema),
    });
    // console.log('data',data)
    const collectMethodSelected = watch('collectMethod');
    
    const onSubmit = (data) => {
        console.log("Data onSubmit");
        console.log(data);
        setValues({endorseFilesId: null});
        setValues({otherFilesId: null});

        setOpen(true);
        uploadFiles(data.endorseFiles).then((uploadFilesResult)=>{
            if(!isEmpty(uploadFilesResult)){
                setValues({endorseFilesId: uploadFilesResult});
                setValues(data);

                if(data.otherFiles.length > 0){
                    uploadFiles(data.otherFiles).then((uploadFilesResult2)=>{
                        if(!isEmpty(uploadFilesResult2)){
                            setValues({otherFilesId: uploadFilesResult2});
                            setValues(data);
                            history.push(`${process.env.REACT_APP_SUB_ROUTE}/confirmation`)
                        }
    
				        setCustomError({"otherFileUpload": {"message": t("errors.frontend.790-E-0706")}});
                        scroll.scrollToTop();
                        setOpen(false);
                        return;
                    })
                }else{
                    history.push(`${process.env.REACT_APP_SUB_ROUTE}/confirmation`)
                }
            }else{
                setCustomError({"endorseFileUpload": {"message": t("errors.frontend.790-E-0705")}});
				scroll.scrollToTop();
                setOpen(false);
                return;
            }
        });

        // setValues(data);
        // history.push(`${process.env.REACT_APP_SUB_ROUTE}/confirmation`);
    };

    const onError = (errors) => {
        scroll.scrollToTop();
        setCustomError();
        setOpen(false);
    }

    useEffect(() => {
        scroll.scrollToTop();
    }, []);

    const handleReset = () => {
        scroll.scrollToTop();
    	clearErrors();
        let newState = {
            applicationReason: '',
            endorseFiles: [],
            otherFiles: [],
            collectMethod: 'post'
        }
        setValues(newState)
        reset({
            applicationReason: '',
            endorseFiles: [],
            otherFiles: [],
            collectMethod: 'post'
        })
    }

    const handleBack = () => {
        if (data.applicationType === 'Duplicate') history.push(`${process.env.REACT_APP_SUB_ROUTE}/selectService`);
        else history.push(`${process.env.REACT_APP_SUB_ROUTE}/permitDetail`);
    }

    const endorseFilesWatch = watch('endorseFiles');
    const otherFilesWatch = watch('otherFiles');
    console.log('watch', {endorseFilesWatch, otherFilesWatch})
    const fileUploadQuota = 8-endorseFilesWatch.length-otherFilesWatch.length;

    console.log('data:', data)
    console.log('getValues: ', getValues())
    
    const [dnsData, setDnsData] = useState(null);

    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    if (dnsData === null) {
        return null;
    }
    
    const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }

    return (
        <main>
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                >
                    <Fade in={open}>
                    <div className={classes.paper}>
                        <LoadingSpinner />
                        <h2 id="transition-modal-title" className="center">{t('confirmation.modalMessage.submission')}</h2>
                        <h2 id="transition-modal-description"  className="center">{t('confirmation.modalMessage.wait')}</h2>
                    </div>
                    </Fade>
                </Modal>
            </div>
            <Helmet>
                <title>{`Screen ID: SC-790-`+siteID()+'-008'}</title>
            </Helmet>
            <Box className="wrapper application">
                <Header langLock="langLocked" />
                <Box className="mainWrapper">
                    <Navbar step="step3" />
                    <Box className="contentWrapper">
                        <ErrorsContainer errors={{...errors, ...customError}} />
                        <StepHeader
                            step="common.step3"
                            title="common.step3Title"
                            mandatory
                        />
                        <form
                            onSubmit={handleSubmit(onSubmit, onError)}
                            onReset={handleReset}
                            noValidate
                        >
                            <FormBox header="step3.reason.title">
                                <Box p={5}>
                                    <Box mb={6}>
                                        <FormControl
                                            error={!!errors.applicationReason}
                                        >
                                            <InputLabel shrink htmlFor="applicationReason">
                                                {t('step3.reason.applicationReason')} <Box component="span" className="danger">*</Box>
                                                {!!errors.applicationReason ? <img id="applicationReason_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                            </InputLabel>

                                            <TextareaAutosize
                                                name="applicationReason"
                                                id="applicationReason"
                                                defaultValue={data.applicationReason}
                                                ref={register()}
                                                rowsMin={5}
                                                aria-label="reason for application"
                                            /> 
                                        </FormControl>
                                    </Box>
                                </Box>
                            </FormBox>
                            <FormBox header="step3.supportDoc.title">
                                <Box p={5}>
                                    <Typography variant="body1">
                                        {t('step3.supportDoc.indicateDoc')}
                                    </Typography>
                                    <Box mb={6}>
                                        <FormControl
                                                error={!!errors.endorseFiles}
                                            >
                                            <InputLabel shrink htmlFor="endorseFiles">
                                                {t('step3.supportDoc.indicateDocOpt1')} <Box component="span" className="danger">*</Box>
                                                {!!errors.endorseFiles ? <img className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                            </InputLabel>
                                            <Box mb={6}>
                                                <FileInput 
                                                    id="endorseFiles" 
                                                    name="endorseFiles" 
                                                    control={control} 
                                                    maxFiles={fileUploadQuota}
                                                    fileType=".pdf, .jpeg, .jpg, .png"
                                                    page="applicationDetail"
                                                    stateKey={"endorseFiles"}
                                                    fileArraySource={data.endorseFiles}
                                                />
                                            </Box>
                                        </FormControl>
                                    </Box>
                                    <Box mb={6}>
                                        <FormControl
                                                error={!!errors.otherFiles}
                                            >
                                            <InputLabel shrink htmlFor="otherFiles">
                                                {t('step3.supportDoc.indicateDocOpt2')}
                                                {!!errors.otherFiles ? <img className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                            </InputLabel>
                                            <Box mb={6}>
                                                <FileInput 
                                                    id="otherFiles"
                                                    name="otherFiles" 
                                                    control={control} 
                                                    maxFiles={fileUploadQuota}
                                                    fileType=".pdf, .jpeg, .jpg, .png"
                                                    page="applicationDetail"
                                                    stateKey={"otherFiles"}
                                                    fileArraySource={data.otherFiles}
                                                />
                                            </Box>
                                        </FormControl>
                                    </Box>
                                    <Typography variant="h6">
                                        {t('step3.supportDoc.notes')}
                                    </Typography>
                                    <ul>
                                        <li>{t('step3.supportDoc.notesMsg1a')}</li>
                                        <li>{t('step3.supportDoc.notesMsg1b')}</li>
                                        <li>{t('step3.supportDoc.notesMsg2')}</li>
                                        <li>{t('step3.supportDoc.notesMsg3')}</li>
                                        <li>{t('step3.supportDoc.notesMsg4')}</li>
                                    </ul>
                                </Box>
                            </FormBox>
                            {    
                                process.env.REACT_APP_PHASE==="1"?(
                                (data.iWant === 'one') &&
                                <FormBox header="step3.permitCollection.title">
                                    <Box p={5}>
                                        <Box mb={6}>
                                            <FormControl
                                                component="fieldset"
                                                error={!!errors.collectMethod}
                                            >
                                                <FormLabel
                                                    component="legend"
                                                >
                                                    {t('step3.permitCollection.collectMethod')} <Box component="span" className="danger">*</Box>
                                                </FormLabel>
                                                <Controller
                                                    control={control}
                                                    name="collectMethod"
                                                    render={
                                                        (props) => (
                                                            <RadioGroup
                                                            aria-label="collectMethod"
                                                            value={props.value} onChange={props.onChange}
                                                            >

                                                                <FormControlLabel
                                                                    value="post"
                                                                    control={<Radio />}
                                                                    label={t('step3.permitCollection.collectMethodOpt1')}
                                                                />
                                                                <FormControlLabel
                                                                value="e-Print"
                                                                control={<Radio />}
                                                                label={t('step3.permitCollection.collectMethodOpt2')}
                                                                />
                                                            </RadioGroup>
                                                        )
                                                    }
                                                />
                                                {!!errors.collectMethod ? <img id="collectMethod_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                            </FormControl>
                                            {
                                                collectMethodSelected === 'e-Print' &&
                                                <ul>
                                                    <li>{t('step3.permitCollection.notesMsg1')}</li>
                                                    <li>{t('step3.permitCollection.notesMsg2')}</li>
                                                    <li>{t('step3.permitCollection.notesMsg3')}</li>
                                                    <li>{t('step3.permitCollection.notesMsg4')}</li>
                                                    <li>{t('step3.permitCollection.notesMsg5')}</li>
                                                </ul>
                                            }
                                        </Box>
                                    </Box>
                                </FormBox>)
                                :
                                <input type="hidden" name="collectMethod" value="post" ref={register()}/> 
                            }
                            <FormBox>
                                <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                >
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        className="secBtn"
                                        onClick={handleBack}
                                    >
                                        {t('common.button.back')}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        type="reset"
                                        className="secBtn"
                                    >
                                        {t('common.button.clear')}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                    >
                                        {t('common.button.next')}
                                    </Button>
                                </Box>
                            </FormBox>
                        </form>
                    </Box>
                </Box>
            </Box>
            <Footer />
        </main>
    )
})
